module.exports = __webpack_public_path__ + "static/media/image2.74c1e57c.png";